import { useState } from 'react';
import CookieConsent from "react-cookie-consent";
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Modal from './components/Modal';
import PrivacyPolicyContent from './components/PrivacyPolicyContent';
import StatuteContent from './components/StatuteContent';

const App = () => {
    const [activeModal, setActiveModal] = useState(null);

    const closeModal = () => setActiveModal(null);

    return (
        <div className="min-h-screen">
            <Header
                onOpenPrivacy={() => setActiveModal('privacy')}
                onOpenTerms={() => setActiveModal('terms')}
            />

            <main>
                <Hero id="home" />
                <About id="about" />
                <Services id="services" />
                <Contact id="contact" />
            </main>

            <Footer
                onOpenPrivacy={() => setActiveModal('privacy')}
                onOpenTerms={() => setActiveModal('terms')}
            />

            <CookieConsent
                location="bottom"
                buttonText="Akceptuję"
                declineButtonText="Odrzucam"
                cookieName="kancelariaFedyszynOlszewskaCookieConsent"
                style={{
                    background: "white",
                    color: "#166534",
                    alignItems: "center",
                    padding: "10px 20px",
                    boxShadow: "0 -5px 15px rgba(0,0,0,0.1)",
                    fontSize: "15px"
                }}
                buttonStyle={{
                    background: "#166534",
                    color: "white",
                    fontSize: "14px",
                    borderRadius: "8px",
                    padding: "12px 24px",
                    fontWeight: "600"
                }}
                expires={150}
            >
                Ta strona korzysta z ciasteczek, aby świadczyć usługi na najwyższym poziomie.
                Dalsze korzystanie ze strony oznacza, że zgadzasz się na ich użycie.
                <button
                    onClick={() => setActiveModal('privacy')}
                    className="ml-2 underline font-bold hover:opacity-80 transition-opacity"
                    style={{ color: "#166534" }}
                >
                    Dowiedz się więcej
                </button>
            </CookieConsent>

            <Modal
                isOpen={!!activeModal}
                onClose={closeModal}
                title={activeModal === 'privacy' ? 'Polityka Prywatności' : 'Regulamin'}
            >
                {activeModal === 'privacy' && <PrivacyPolicyContent />}

                {activeModal === 'terms' && <StatuteContent />}
            </Modal>
        </div>
    );
};

export default App;